module.exports = __webpack_public_path__ + "static/jquery-light-box-8f067344910dea9bff1b9373026a0c53.jpg";